export default {
	er_cover_default_title: 'Przegląd wyników',
	er_page_success_metrics: 'Co zmieniło się w tym miesiącu',
	er_page_success_metrics_range: 'Co zmieniło się w tym okresie',
	er_page_success_metrics_week: 'Co zmieniło się w tym tygodniu',
	er_page_comparison: 'Podsumowanie porównawcze',
	er_page_period_summary: 'Podsumowanie miesiąca',
	er_page_period_summary_range: 'Podsumowanie okresu',
	er_page_period_summary_week: 'Podsumowanie tygodnia',
	er_page_each_month: 'Każdy miesiąc',
	er_page_rooms: 'Pomieszczenia',
	er_rooms_note: 'Każde pomieszczenie w {month}, najlepszy wynik na górze.',
	er_page_shift_comparison: 'Porównanie według zmiany',
	er_page_shift_summary: 'Według zmiany',
	er_page_response_time: 'Średni czas reakcji (min)',
	er_page_avg_score: 'Wynik doświadczenia',
	er_page_complaints_vs_visits: 'Zgłoszenia vs Wizyty',
	er_page_performance_trends: 'Trendy wydajności',
	er_page_complaint_drivers: 'Źródła skarg',

	er_board_working: 'Lepiej niż {month}',
	er_board_attention: 'Wymaga uwagi względem {month}',
	er_board_empty: 'W tym miesiącu nie ma istotnych zmian.',
	er_board_empty_range: 'W tym okresie nie ma istotnych zmian.',
	er_board_empty_week: 'W tym tygodniu nie ma istotnych zmian.',
	er_findings_intro: 'Porównanie z {month}. Pokazano tylko istotne zmiany.',
	er_verdict_improved: 'Poprawa',
	er_verdict_watch: 'Wymaga uwagi',

	er_col_metric: 'Wskaźnik',
	er_col_avg: 'Śr. YTD',
	er_col_lifetime_avg: 'Śr. od początku',
	er_comparison_note: 'Śr. YTD to wynik od stycznia do {month}.',
	er_lifetime_note: 'Od początku to średnia miesięczna od pierwszego dnia z danymi do {month}.',
	er_comparison_note_week: 'Tydzień raportu jest porównywany z wybranym poprzednim tygodniem.',
	er_period_only_note: 'Dane dotyczą tylko {month}.',
	er_each_month_note: 'Każdy miesiąc wybranego okresu. Miesiąc bez danych pozostaje pusty.',
	er_col_inc_dec: 'Zmiana',
	er_col_complaint: 'Zgłoszenie',
	er_col_qty: 'Ilość',
	er_total: 'Razem',

	er_metric_avg_score: 'Wynik doświadczenia',
	er_metric_avg_response_time: 'Średni czas reakcji',
	er_metric_cleaner_arrivals: 'Przybycia sprzątających',
	er_metric_supervisor_inspections: 'Kontrole supervisorów',
	er_metric_complaints_vs_visits_pct: 'Zgłoszenia vs wizyty (%)',
	er_metric_complaints: 'Zgłoszenia',
	er_metric_customer_visits: 'Wizyty',
	er_metric_expired_slas: 'Przeterminowane SLA',
	er_unit_min: 'min',
	er_stat_expected_sla: 'Oczekiwane SLA',
	er_stat_vs_minutes: 'vs {value} w {month}',
	er_stat_vs_count: 'vs {value} w {month}',
	er_label_complaints: 'Zgłoszenia',
	er_label_visits: 'Wizyty',
	er_label_complaints_per_visits: 'Zgłoszenia / wizyty',
	er_chart_ratio: 'Stosunek zgłoszeń do wizyt',
	er_chart_ytd_window: 'Od stycznia do {month}.',
	er_cv_formula: 'Zgłoszenia podzielone przez wizyty w toaletach, w procentach: ({complaints} ÷ {visits}) × 100 = {ratio}% w {month}.',
	er_export_kpis_title: 'Co zawiera raport',
	er_export_kpis_desc: 'Wszystko to jest w raporcie. Wyłącz pozycję, której nie chcesz.',
	er_export_select_all: 'Zaznacz wszystko',
	er_export_clear_all: 'Wyczyść wszystko',
	er_export_summary: '{report} vs {compare}',
	er_export_period_title: 'Okres raportu',
	er_export_grain: 'Raport według',
	er_export_grain_month: 'Miesiąc',
	er_export_grain_week: 'Tydzień',
	er_export_week_starts: 'Tydzień zaczyna się w',
	er_export_week_starts_sunday: 'niedzielę',
	er_export_week_starts_monday: 'poniedziałek',
	er_export_report_month: 'Miesiąc raportu',
	er_export_from_month: 'Od',
	er_export_to_month: 'Do',
	er_export_period_note_range: 'Raport sumuje każdy miesiąc od początku do końca. Przy włączonym porównaniu używany jest poprzedni okres o tej samej długości. Dane od początku roku nadal liczą się od stycznia do miesiąca końcowego.',
	er_export_summary_range: '{from} – {to}',
	er_export_summary_range_vs: '{from} – {to} vs {compare}',
	er_export_compare_range_note: 'Poprzedni okres o tej samej długości.',
	er_export_report_week: 'Tydzień raportu',
	er_export_compare_month: 'Porównaj z',
	er_export_shift: 'Zmiana',
	er_export_shift_all: 'Wszystkie zmiany',
	er_export_no_shifts: 'W tej lokalizacji nie ma aktywnych zmian.',
	er_export_render_failed: 'Nie udało się poprawnie wygenerować raportu, więc nie został pobrany. Odśwież stronę i spróbuj ponownie.',
	er_export_comparison: 'Porównanie',
	er_export_include_previous: 'Uwzględnij poprzedni okres',
	er_export_comparison_on: 'Włączone',
	er_export_comparison_off: 'Wyłączone',
	er_export_no_previous_data: 'Przed tym okresem nie ma danych, więc nie ma z czym porównywać.',
	er_export_compare_previous: 'Poprzedni miesiąc',
	er_export_compare_previous_week: 'Poprzedni tydzień',
	er_export_compare_last_year: 'Ten sam miesiąc rok temu',
	er_export_no_periods: 'Ta lokalizacja potrzebuje co najmniej jednego miesiąca danych, aby wyeksportować raport.',
	er_export_no_periods_week: 'Ta lokalizacja potrzebuje co najmniej jednego tygodnia danych, aby wyeksportować raport.',
	er_export_period_note: 'Wyświetlane są tylko miesiące z danymi. Dane od początku roku zawsze obejmują styczeń do miesiąca raportu.',
	er_export_period_note_week: 'Wyświetlane są tylko tygodnie z danymi. Porównanie zawsze dotyczy wcześniejszego tygodnia.',
	er_export_period_note_single_week: 'Wyświetlane są tylko tygodnie z danymi.',

	er_find_response_time_title: 'Średni czas reakcji',
	er_find_response_time_change:
		'Zmienił się z {previous} na {current} min ({change}).',
	er_find_avg_score_title: 'Wynik doświadczenia',
	er_find_score_eased: 'Spadł z {previous} do {current}.',
	er_find_score_improved: 'Wzrósł z {previous} do {current}.',
	er_find_score_ytd_inline: 'Zgodny ze średnią od początku roku ({ytd}).',
	er_find_score_ytd_inline_range: 'Zgodnie ze średnią od stycznia do {endMonth} ({ytd}).',
	er_find_score_ytd_against: 'Średnia od początku roku: {ytd}.',
	er_find_score_ytd_against_range: 'Średnia od stycznia do {endMonth}: {ytd}.',
	er_find_complaints_ratio_title: 'Stosunek zgłoszeń do wizyt',
	er_find_complaints_ratio_improved: 'Poprawił się z {previous} do {current}.',
	er_find_complaints_ratio_rose: 'Zmienił się z {previous} do {current}.',

	er_nar_cv_year_improved: 'Zgłoszenia względem wizyt w toaletach poprawiły się z {from} do {to} w ciągu roku.',
	er_nar_cv_year_rose: 'Zgłoszenia względem wizyt w toaletach wzrosły z {from} do {to} w ciągu roku.',
	er_nar_cv_moved: 'Zgłoszenia względem wizyt w toaletach zmieniły się z {previous} do {current}.',
	er_nar_cv_current: 'Zgłoszenia względem wizyt w toaletach wynoszą {current}.',
	er_nar_types_total: 'Łączna liczba zgłoszeń {total}.',
	er_nar_types_1: 'Główne zgłoszenie: {a} ({ap}%).',
	er_nar_types_2: 'Główne zgłoszenie: {a} ({ap}%), następnie {b} ({bp}%).',
	er_nar_types_3: 'Główne zgłoszenie: {a} ({ap}%), następnie {b} ({bp}%) i {c} ({cp}%).',
	er_find_rooms_slowest: 'Pomieszczenia z najdłuższym czasem reakcji w tym miesiącu: {rooms}.',
	er_find_rooms_slowest_range: 'Pomieszczenia z najdłuższym czasem reakcji w tym okresie: {rooms}.',
	er_find_rooms_slowest_week: 'Pomieszczenia z najdłuższym czasem reakcji w tym tygodniu: {rooms}.',
	er_find_rooms_lowest_score: 'Pomieszczenia z najniższym wynikiem w tym miesiącu: {rooms}.',
	er_find_rooms_lowest_score_range: 'Pomieszczenia z najniższą oceną w tym okresie: {rooms}.',
	er_find_rooms_lowest_score_week: 'Pomieszczenia z najniższym wynikiem w tym tygodniu: {rooms}.',

	er_find_so_what_ratio: 'Większość zmiany pochodziła z {rooms}.',
	er_find_so_what_type: 'Główna skarga: {name} ({percent}%).',
	er_hot_slowest: 'Pomieszczenia z najdłuższym czasem reakcji',
	er_hot_expired_slas: 'Pomieszczenia, które przekroczyły SLA',
	er_hot_ratio: 'Pomieszczenia z największą zmianą wskaźnika skarg',
	er_hot_top_type: 'Pomieszczenia z największą liczbą skarg „{name}”',
	er_hot_col_room: 'Pomieszczenie',
	er_col_response: 'Reakcja',
	er_col_cleaners: 'Sprzątanie',
	er_col_score: 'Wynik',
	er_chart_sla: 'SLA',
	er_hot_col_ratio: 'Wskaźnik',
	er_hot_col_change: 'Zmiana',
	er_hot_col_count: 'Ilość',
	er_hot_empty: 'Brak wyróżnień na poziomie pomieszczeń w tym miesiącu.',
	er_hot_empty_range: 'Brak wyróżnień na poziomie pomieszczeń w tym okresie.',
	er_hot_empty_week: 'Brak wyróżnień na poziomie pomieszczeń w tym tygodniu.',
	er_cover_highlights: 'Ten miesiąc',
	er_cover_highlights_range: 'Ten okres',
	er_cover_highlights_week: 'Ten tydzień',
	er_cover_score_rose: 'Wynik doświadczenia wzrósł.',
	er_cover_score_eased: 'Wynik doświadczenia spadł.',
	er_cover_response_improved: 'Czas reakcji się poprawił.',
	er_cover_response_slowed: 'Czas reakcji się wydłużył.',
	er_cover_ratio_fell: 'Stosunek skarg do wizyt spadł.',
	er_cover_ratio_rose: 'Stosunek skarg do wizyt wzrósł.',
	er_export_pdf: 'PDF pulpitu',
	er_export_executive: 'Raport wykonawczy',
	'executive-report': 'Raport wykonawczy',
	er_export_csv: 'CSV',
	er_export_status_title: 'Tworzenie raportu',
	er_export_status_fetch: 'Wczytywanie liczb',
	er_export_status_layout: 'Układanie stron',
	er_export_status_page: 'Strona {page} z {total}',
	er_footer_copyright: 'Ten raport został wygenerowany w systemie BuzzzTech.',
	er_contact_line: 'Masz pytania lub chcesz dokładniej przeanalizować dane? Skontaktuj się z zespołem Customer Success BuzzzTech: {email} lub {phone}.',
};
